import _emoji from "react-easy-emoji";

export const emoji = str => {
  return _emoji(str, {
    baseUrl: "https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/"
  });
};
